import React, { useState, useEffect } from "react";
import { Tabs } from "antd";
import { useNavigate } from "react-router";
import TripList from "./tripList";
// import CreateLCR from "./createLCR";
import back_img from "../../../assests/images/rightVector.svg";
import "./style.scss";

const LCR = () => {
  // const history = useLocation();
  const navigate = useNavigate();
  const [step, setStep] = useState();

  const items = [
    {
      key: "1",
      label: "Outgoing Trip",
      children: <TripList filterType="OUTGOING_HUBS"/>,
    },
    {
      key: "2",
      label: "Connecting Trip",
      children: <TripList filterType="CONNECTING_HUBS"/>,
    },
  ];

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab") || "1";
    setStep(tab);
  }, []);

  const onChange = (key) => {
    setStep(key);
    navigate(`/lcr-generation?tab=${key}`);
  };

  return (
    <div className="consolidated-tab-cntr">
      <div className="top-wrapper space-between">
        <div className="heading align-center">
          <img
            src={back_img}
            onClick={() => navigate("/dashboard")}
            style={{ cursor: "pointer" }}
          />
          <p
            style={{
              margin: "0",
              paddingLeft: "5px",
              fontWeight: "700",
              fontSize: "18px",
              lineHeight: "32px",
              letterSpacing: "-0.25px",
              color: "#061624",
            }}
          >
            <b>LCR</b>
          </p>
        </div>
      </div>
      <Tabs
        destroyInactiveTabPane
        defaultActiveKey={step}
        activeKey={step}
        items={items}
        onChange={onChange}
      />
    </div>
  );
};
export default LCR;
